import React from 'react';
import './Loader.less';
import { Item, Row, Column } from 'react-plan';

type Props = {

}

class Loader extends React.Component {

  description: 'Shows a loading animation.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return <Row justify="center" className="m-t-xxl">

        <Item>
      <h1 className="txt-center">LOADING</h1>
      <img
        alt="galaxy"
        className="rotating galaxy"
        src={ require('../../../img-layout/loading-animation.gif') } />
          </Item>

    </Row>
      ;
  }
  /* End React Component LifeCycle Methods */
}

export default Loader;

//Unit test entry point
export const _Loader = Loader;


/** WEBPACK FOOTER **
 ** ./src/js/app/Loader/Loader.jsx
 **/